export const FLIGHT_STATUS_CARD_TYPES = {
  STATUS_CARD: "STATUS_CARD",
  OTP_WEATHER: "OTP_WEATHER",
  AIRCRAFT_INFO: "AIRCRAFT_INFO",
};

export const FLIGHT_SEARCH_TYPE_OPTIONS = {
  BY_ROUTE: "byRoute",
  BY_AIRPORT: "byAirport",
  BY_FLIGHT: "byFlight",
};
